<template>
    <div>
        <HeaderComponent :brand-word="brand"/>
        <CalculatorComponent
            :brand="brand"
            :logo="logo"
            :brand-header="brandHeader"
            :models-data-string="modelsDataString"
            :models-data="modelsData"
            :iown-link="whatIsIownLink"
            :term-options="termOptions"
            :mileage-options="mileageOptions"
            :kilometres-tooltip="kilometresTooltip"
            :interest-rate="interestRate"
            :client-id="clientId"
            contact-us-component="peugeot-contact-us"
            tooltip-white
        />
        <FooterComponent :brand-word="brand"/>
    </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from 'vue'
import HeaderComponent from './HeaderComponent.vue'
import CalculatorComponent from './CalculatorComponent.vue'
import FooterComponent from './FooterComponent.vue'
import CONSTANTS from '../data/constants'
import loadedModelsData from '../data/models_data_peugeot.json'

export default defineComponent({
  name: 'PeugeotFinanceCalculator',
  components: {
    HeaderComponent,
    FooterComponent,
    CalculatorComponent
  },
  setup () {
    const brand = CONSTANTS.BRANDS.PEUGEOT
    const whatIsIownLink = CONSTANTS.WHAT_IS_IOWN_LINK.PEUGEOT
    const termOptions = CONSTANTS.TERM_OPTIONS.PEUGEOT
    const mileageOptions = CONSTANTS.MILEAGE_OPTIONS.PEUGEOT
    const kilometresTooltip = CONSTANTS.KILOMETRES_TOOLTIP.PEUGEOT
    const interestRate = CONSTANTS.INITIAL_INTEREST_RATE.PEUGEOT
    const clientId = process.env.VUE_APP_PEUGEOT_CLIENT_ID

    const logo = '/img/peugeot-logo.png'
    const brandHeader = '/img/peugeot-title.png'
    const modelsData = reactive(Array.from(loadedModelsData))
    const modelsDataString = ref('')

    const init = () => {
      document.getElementById('favicon').href = '../favicon.ico'
      document.getElementById('page_title').text = 'Peugeot - iOWN'
      document.documentElement.style.setProperty('--button-accent', '#00a3e0')
      document.documentElement.style.setProperty('--button-color', '#ffffff')
      document.documentElement.style.setProperty('--header-line-bg', '#e6f6fc')
      document.documentElement.style.setProperty('--tooltip-accent', '#00a3e0')
      document.documentElement.style.setProperty('--font', "'Lato', sans-serif")

      modelsDataString.value = JSON.stringify(modelsData)
    }

    onMounted(() => {
      init()
    })
    return {
        brand,
        whatIsIownLink,
        termOptions,
        mileageOptions,
        logo,
        brandHeader,
        modelsData,
        modelsDataString,
        kilometresTooltip,
        interestRate,
        clientId
    }
  }
})
</script>
